
import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({
  name: "MarketingHeader"
})
export default class MarketingHeader extends Vue {}
